import { z } from '@/libs/zod';

export const controlsSchema = z.enum([
  'Backspace',
  'Delete',
  'ArrowLeft',
  'ArrowRight',
  'Tab',
]);

export type ControlType = z.infer<typeof controlsSchema>;
export const CONTROL_KEYS: ControlType[] = [
  'Backspace',
  'Delete',
  'ArrowLeft',
  'ArrowRight',
  'Tab',
];
